import Man2Icon from '@mui/icons-material/Man2';
import WcIcon from '@mui/icons-material/Wc';
import Woman2Icon from '@mui/icons-material/Woman2';
import ImageIcon from '@mui/icons-material/Image';
import VideoIcon from '@mui/icons-material/VideoFile';
import AudioIcon from '@mui/icons-material/AudioFile';
import DocumentIcon from '@mui/icons-material/Description';
import {
    MemberTypeLabel,
    MissionVisibilityLabel,
    MissionStatusLabel,
    MemberGenderLabel,
    AntennaTypeLabel,
    VolunteerMissionAffinityLabel,
    MemberStatusLabel,
    ResourceTypeLabel,
    TaskTypeLabel,
} from '@domain/labels';
import {
    MissionVisibilityMainVolunteerCloseIcon,
    MissionVisibilityMainVolunteerOpenIcon,
    MissionVisibilityPrivateCloseIcon,
    MissionVisibilityPrivateOpenIcon,
    MissionVisibilityStaffIcon,
    MissionVisibilityVolunteerCloseIcon,
    MissionVisibilityVolunteerOpenIcon,
} from '@app/mission/MissionVisibilityIcons';
import {
    VolunteerIcon,
    MainVolunteerIcon,
    StaffIcon,
} from '@app/member/MemberIcon';

// TODO : move to sdk and share with mobile

export const defaultAntennaTypes: AntennaTypeLabel[] = [
    { value: 'VOLUNTEER', label: 'Volunteer', icon: VolunteerIcon },
    { value: 'OFFICE', label: 'Office', icon: StaffIcon },
];

export const defaultMissionStatusLabels: MissionStatusLabel[] = [
    { value: 'DRAFT', label: 'Draft', color: 'default' },
    {
        value: 'WAITING_FOR_VALIDATION',
        label: 'Waiting for Validation',
        color: 'error',
    },
    { value: 'VALID', label: 'Valid', color: 'secondary' },
    {
        value: 'CALL_FOR_VOLUNTEERS',
        label: 'Call for Volunteers',
        color: 'warning',
    },
    { value: 'READY_FOR_ACTION', label: 'Ready for Action', color: 'info' },
    { value: 'COMPLETED', label: 'Completed', color: 'success' },
    { value: 'ARCHIVED', label: 'Archived', color: 'default' },
    { value: 'CANCELLED', label: 'Cancelled', color: 'default' },
];

export const defaultMissionPipelineStatuses = ['won'];

export const defaultMemberStatusLabels: MemberStatusLabel[] = [
    { value: 'cold', label: 'Cold', color: '#7dbde8' },
    { value: 'warm', label: 'Warm', color: '#e8cb7d' },
    { value: 'hot', label: 'Hot', color: '#e88b7d' },
];

export const defaultMemberGenderLabels: MemberGenderLabel[] = [
    { value: 'MALE', label: 'He/Him', icon: Man2Icon },
    { value: 'FEMALE', label: 'She/Her', icon: Woman2Icon },
    { value: 'OTHER', label: 'Non-binary', icon: WcIcon },
];

export const defaultMemberTypeLabels: MemberTypeLabel[] = [
    { value: 'VOLUNTEER', label: 'Volunteer', icon: VolunteerIcon },
    {
        value: 'MAIN_VOLUNTEER',
        label: 'Main volunteer',
        icon: MainVolunteerIcon,
    },
    { value: 'STAFF', label: 'Staff', icon: StaffIcon },
];

export const defaultMissionVisibilityLabels: MissionVisibilityLabel[] = [
    {
        value: 'VOLUNTEER_CLOSE',
        label: 'Any member of this antenna only',
        icon: MissionVisibilityVolunteerCloseIcon,
    },
    {
        value: 'VOLUNTEER_OPEN',
        label: 'Any member of any antenna',
        icon: MissionVisibilityVolunteerOpenIcon,
    },
    {
        value: 'MAIN_VOLUNTEER_CLOSE',
        label: 'Main volunteers & staff of this antenna only',
        icon: MissionVisibilityMainVolunteerCloseIcon,
    },
    {
        value: 'MAIN_VOLUNTEER_OPEN',
        label: 'Main volunteers & staff of any antenna',
        icon: MissionVisibilityMainVolunteerOpenIcon,
    },
    {
        value: 'STAFF',
        label: 'Staff of any antenna',
        icon: MissionVisibilityStaffIcon,
    },
    {
        value: 'PRIVATE_OPEN',
        label: 'Private (link) — members with the link, participants, or staff',
        icon: MissionVisibilityPrivateOpenIcon,
    },
    {
        value: 'PRIVATE_CLOSE',
        label: 'Private (closed) — registered participants and staff only',
        icon: MissionVisibilityPrivateCloseIcon,
    },
];

export const defaultResourceTypeLabels: ResourceTypeLabel[] = [
    { value: 'IMAGE', label: 'Image', icon: ImageIcon, color: 'primary' },
    { value: 'VIDEO', label: 'Video', icon: VideoIcon, color: 'secondary' },
    { value: 'AUDIO', label: 'Audio', icon: AudioIcon, color: 'success' },
    {
        value: 'DOCUMENT',
        label: 'Document',
        icon: DocumentIcon,
        color: 'default',
    },
];

export const defaultVolunteerMissionAffinityLabels: VolunteerMissionAffinityLabel[] =
    [
        { value: 'AWARENESS_STAND', label: 'Awar. Stand' },
        { value: 'AWARENESS_ECL', label: 'Awar. ECL' },
        { value: 'SCHOOL', label: 'School' },
        { value: 'FIELD', label: 'Field' },
        { value: 'COORDINATION', label: 'Coordination' },
        { value: 'REINFORCEMENT', label: 'Reinforcement' },
        { value: 'OTHER', label: 'Other' },
    ];

export const defaultTaskTypeLabels: TaskTypeLabel[] = [
    { value: 'None', label: 'None' },
    { value: 'Email', label: 'Email' },
    { value: 'Demo', label: 'Demo' },
    { value: 'Lunch', label: 'Lunch' },
    { value: 'Meeting', label: 'Meeting' },
    { value: 'Follow-up', label: 'Follow-up' },
    { value: 'Thank you', label: 'Thank you' },
    { value: 'Ship', label: 'Ship' },
    { value: 'Call', label: 'Call' },
];
